import React from "react";
import PropTypes from "prop-types";
import DataGrid, {DataGridItem} from "components/data-grid";
import {injectIntl} from "react-intl";
import styles from "./styles/event-data-tab.css.js";
import withStyles from "components/with-styles";
import Link, {LinkWithIcon} from "components/link";
import {TextDisplay} from "components/display-data";
import {RestrictedToAdmin} from "components/auth";
import I18nBoolean from "components/i18n-boolean";
import OptionalDate from "components/optional-date";
import FormHelperText from "components/form/form-helper-text";
import {Restricted, permissions} from "components/auth";

const EventDataTab = ({authorizedRecording, event, intl, classes, showAuthorized}) => {
    return (
        <>
            <DataGrid>
                <DataGridItem>
                    {event.contract && (
                        <LinkWithIcon
                            text={event.contract.description}
                            iconName="library-books"
                            color="primary"
                            href={`/contract/details/${event.contract.id}`}
                        />
                    )}
                </DataGridItem>
                <DataGridItem>
                    {event.contract && event.contract.deployment && (
                        <LinkWithIcon
                            text={event.contract.deployment.codename}
                            iconName="settings-input-antenna"
                            color="primary"
                            href={`/deployment/details/${event.contract.deployment.id}`}
                        />
                    )}
                </DataGridItem>
                <RestrictedToAdmin>
                    <DataGridItem>
                        <OptionalDate
                            label={intl.formatMessage({id: "event.createdAt"})}
                            value={event.createdAt ? event.createdAt * 1000 : null}
                            icon="event-available"
                        />
                    </DataGridItem>
                    {event.startedByUser && (
                        <DataGridItem>
                            <FormHelperText text={intl.formatMessage({id: "event.startedByUserName"})}/>
                            <LinkWithIcon
                                text={event.startedByUser.name}
                                iconName="person"
                                color="primary"
                                href={`/user/details/${event.startedByUser.username}`}
                            />
                        </DataGridItem>
                    )}
                    {event.finishedByUser && (
                        <DataGridItem>
                            <FormHelperText text={intl.formatMessage({id: "event.finishedByUserName"})}/>
                            <LinkWithIcon
                                text={event.finishedByUser.name}
                                iconName="person"
                                color="primary"
                                href={`/user/details/${event.finishedByUser.username}`}
                            />
                        </DataGridItem>
                    )}
                </RestrictedToAdmin>
                {event.graphicSet && (
                    <DataGridItem>
                        <LinkWithIcon
                            text={event.graphicSet.name}
                            iconName="dashboard"
                            color="primary"
                            href={`/graphicset/details/${event.graphicSet.id}/customerId/${event.graphicSet.customerId}`}
                        />
                    </DataGridItem>
                )}
                {event.plenarySessionUrl && (
                    <DataGridItem>
                        <LinkWithIcon
                            text={intl.formatMessage({id: "event.plenarySessionUrl"})}
                            iconName="gavel"
                            color="primary"
                            onClick={() => window.open(event.plenarySessionUrl, "_blank")}
                        />
                    </DataGridItem>
                )}
            </DataGrid>

            {event.subdeployment && (
                <DataGrid>
                    <DataGridItem>
                        <TextDisplay className={classes.data} label={intl.formatMessage({id: "event.subdeployment"})}>
                            {event.subdeployment.name}
                        </TextDisplay>
                    </DataGridItem>
                </DataGrid>
            )
            }

            <DataGrid>
                <DataGridItem>
                    <TextDisplay className={classes.data} label={intl.formatMessage({id: "event.bertConfigId"})}>
                        {event.bertConfigId}
                    </TextDisplay>
                </DataGridItem>

                {event.roomTemplate && (
                    <>
                        <DataGridItem>
                            <TextDisplay className={classes.data} label={intl.formatMessage({id: "event.template"})}>
                                <Restricted permissions={[permissions.roomtemplate_view]}
                                            fallback={event.roomTemplate.codename}>
                                    <Link
                                        href={`/roomTemplate/details/${event.roomTemplateId}/contractId/${event.contract?.id}`}
                                        className={classes.highlightedLink}>
                                        {event.roomTemplate.codename}
                                    </Link>
                                </Restricted>
                            </TextDisplay>
                        </DataGridItem>
                        <DataGridItem>
                            <RestrictedToAdmin>
                                <TextDisplay className={classes.data}
                                             label={intl.formatMessage({id: "event.testTemplate"})}>
                                    <I18nBoolean value={event.roomTemplate.test}/>
                                </TextDisplay>
                            </RestrictedToAdmin>
                        </DataGridItem>

                    </>
                )}
                {showAuthorized && <DataGridItem>
                    <TextDisplay className={classes.data} label={intl.formatMessage({id: "event.authorization.label"})}>
                        {authorizedRecording ? intl.formatMessage({id: "event.authorization.ok"}) : intl.formatMessage({id: "event.authorization.ko"})}
                    </TextDisplay>
                </DataGridItem>}
            </DataGrid>
        </>
    );
};

EventDataTab.propTypes = {
    /**
     * Data to represent
     **/
    event: PropTypes.object,
};

export default withStyles(styles)(injectIntl(EventDataTab));
